import { render, staticRenderFns } from "./AddIssuelog.vue?vue&type=template&id=89b88920&"
import script from "./AddIssuelog.vue?vue&type=script&lang=js&"
export * from "./AddIssuelog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports